import React from "react";

import PageWrapper from "../components/PageWrapper";
import ProtectedRoute from "../components/ProtectedRoute";
import TimeTracker from "../sections/tools/TimeTracker";
import TimeTrackerPreview from "../sections/tools/TimeTrackerPreview";
import CTA from "../sections/landing4/CTA";

const TimeTrackerPage = () => (
  <PageWrapper>
    <ProtectedRoute requiredRole="client" preview={<TimeTrackerPreview />}>
      <TimeTracker />
    </ProtectedRoute>
    <CTA />
  </PageWrapper>
);

export default TimeTrackerPage;
